import { IConseiller } from '../models.interfaces/conseiller.model.interface';

export class EmptyConseiller implements IConseiller {
    codeClient = '';
    codeFournisseur = '';
    fullName = '';
    zoneTvaId = null;
}
